import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=4f385bfe&scoped=true&"
import script from "./TextInput.vue?vue&type=script&lang=ts&"
export * from "./TextInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=4f385bfe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f385bfe",
  null
  
)

export default component.exports